

import React, { useState, useEffect } from 'react';
import Button from './Button';

const DomainAuthorizationHelpModal = ({ isOpen, onClose }) => {
  const [hostname, setHostname] = useState('');

  useEffect(() => {
    if (isOpen) {
      // We can safely access window.location here as this is a client-side component.
      setHostname(window.location.hostname);
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-75 z-50 flex justify-center items-center p-4" 
      aria-modal="true" 
      role="alertdialog"
    >
      <div className="bg-white rounded-lg shadow-2xl p-6 md:p-8 w-full max-w-2xl mx-auto space-y-6">
        <div className="text-center">
            <svg className="w-16 h-16 mx-auto text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <h2 className="mt-4 text-2xl font-extrabold text-secondary-800">Action Required: Authorize Domain for Authentication</h2>
        </div>

        <p className="text-base text-secondary-600 text-center">
          Firebase Authentication has blocked this application because its domain is not on the authorized list. This is a security measure to prevent unauthorized use of your Firebase project.
        </p>

        <div className="space-y-4 text-left">
          <h3 className="text-lg font-semibold text-secondary-700">How to Fix This:</h3>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-600 text-white flex items-center justify-center font-bold text-lg">1</div>
            <div>
              <h4 className="font-semibold text-secondary-800">Go to Firebase Console</h4>
              <p className="text-sm text-secondary-600">
                Navigate to your Firebase project, then go to the <span className="font-bold">Authentication</span> section.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-600 text-white flex items-center justify-center font-bold text-lg">2</div>
            <div>
              <h4 className="font-semibold text-secondary-800">Add Authorized Domain</h4>
              <p className="text-sm text-secondary-600">
                Click on the <span className="font-bold">Settings</span> tab, then find the <span className="font-bold">Authorized domains</span> list and click <span className="font-bold">Add domain</span>.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-600 text-white flex items-center justify-center font-bold text-lg">3</div>
            <div>
              <h4 className="font-semibold text-secondary-800">Enter Your Domain</h4>
              <p className="text-sm text-secondary-600">
                Copy and paste the following domain into the text box and click "Add":
              </p>
              <pre className="mt-2 text-sm bg-secondary-900 text-white p-3 rounded-md overflow-x-auto">
                <code>{hostname || 'Loading your domain...'}</code>
              </pre>
               <p className="text-sm text-secondary-600 mt-2">
                After adding the domain, refresh this page and try logging in again.
              </p>
            </div>
          </div>
        </div>
        
        <div className="mt-8 flex justify-center">
          <Button variant="primary" size="lg" onClick={onClose}>
            I have added the domain
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DomainAuthorizationHelpModal;